import { cn } from '@/shared/utils/helpers'

export const NavButton: React.FC<
	React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ disabled, className, ...props }) => {
	return (
		<button
			type="button"
			disabled={disabled}
			className={cn(
				'flex h-8 w-8 items-center justify-center rounded-full bg-[#3d3d3d] text-white transition-opacity',
				disabled
					? 'cursor-not-allowed opacity-50'
					: 'cursor-pointer hover:opacity-80',
				className
			)}
			{...props}
		/>
	)
}
